import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeatureRoutingModule } from './feature-routing.module';
import { FeatureComponent } from './feature.component';
import { CoreModule } from "../core/core.module";
import { SharedModule } from "../shared/shared.module";
import { RequestModule } from "./request/request.module";
import {ReportsModule} from "./reports/reports.module";
import {TrackingModule} from "./tracking/tracking.module";

@NgModule({
  declarations: [
    FeatureComponent
  ],
  imports: [
    CommonModule,
    FeatureRoutingModule,
    CoreModule,
    SharedModule,
    RequestModule,
    ReportsModule,
    TrackingModule
  ]
})
export class FeatureModule {
}
